import BaseModal from "@components/modals/BaseModal";
import Button from "@components/ui/buttons/Button";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import { formatTime } from "@utils/timeGrid";

interface JobMergeModalProps {
  draggedClientName: string;
  targetClientName: string;
  mergedStartHour: number;
  mergedDurationHours: number;
  onMerge: () => void;
  onCancel: () => void;
}

export default function JobMergeModal({
  draggedClientName,
  targetClientName,
  mergedStartHour,
  mergedDurationHours,
  onMerge,
  onCancel,
}: JobMergeModalProps) {
  const mergedEnd = mergedStartHour + mergedDurationHours;

  return (
    <BaseModal
      title="Fusionner les travaux"
      onClose={onCancel}
      width="max-w-md"
    >
      <div className="flex flex-col gap-4 p-4">
        <div className="text-h3" style={{ fontFamily: "Poppins", color: "#525252" }}>
          Ces deux magnets appartiennent au même ordre, mais le bloc fusionné passerait
          sur une pause. Fusionner quand même en un seul créneau ?
        </div>

        <div
          className="flex flex-col gap-2 p-3 rounded-lg"
          style={{ background: "#F0F4FF", border: "1px solid #C7D2FE" }}
        >
          <div className="text-h3 font-medium" style={{ color: "#4338CA" }}>
            Résultat de la fusion :
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-h4" style={{ color: "#6366F1" }}>
              {formatTime(mergedStartHour)} — {formatTime(mergedEnd)} ({mergedDurationHours}h)
            </div>
            <div className="text-h4" style={{ color: "#6366F1" }}>
              {draggedClientName}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t p-4 flex flex-row justify-end gap-2">
        <SecondaryButton variant="small" onClick={onCancel}>
          Annuler
        </SecondaryButton>
        <Button
          variant="small"
          label="Fusionner"
          onClick={onMerge}
        />
      </div>
    </BaseModal>
  );
}
